<template>
    <div id="app" >
        <router-view />
    </div>
  </template>

<script>
export default {
  name: 'CustomLayout',
  data () {
    return {}
  },
  computed: {

  },

  created () {},
}
</script>

  <style lang="scss">
    @import "@/assets/styles/index.scss";
    @import "@/assets/mobile/index.scss";
  </style>
